import React from 'react';

const SecondaryButton = ({ children, onClick, className = '' }) => {
    return (
        <button
            onClick={onClick}
            className={`px-3 py-2 text-sm sm:px-6 sm:py-3 sm:text-base bg-earth-50 text-earth-800 hover:bg-earth-100 font-semibold rounded-3xl transition-colors duration-200 ${className}`}
        >
            {children}
        </button>
    );
};

export default SecondaryButton;

